/*
 * Copyright (C) 2018 Frontier Developments PLC.
 */

/**
 * Base error class used to provide extended definition to the Error type.
 *
 * @author Jonny Cook <jcook@frontier.co.uk>
 */
export default class BaseError {
    constructor() {
        // @ts-ignore
        Error.apply(this, arguments);
    }
}
